import axios from "axios";
import { FETCH_CATEGORY_EXPENSE_BIGS_FAILURE, FETCH_CATEGORY_EXPENSE_BIGS_REQUEST, FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS, FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS_2, FETCH_CATEGORY_EXPENSE_BIG_FAILURE, FETCH_CATEGORY_EXPENSE_BIG_REQUEST, FETCH_CATEGORY_EXPENSE_BIG_SUCCESS, } from "../../app/actions/actions";
import { ROUTES } from "../../config/routingUrl";
import { dureeDeVie, getAndCheckLocalStorage, setWithExpiration } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { baseurl, checkWordInURL } from "../../utils/url/baseurl";
import { saveDataToFile } from "../DataLocal";
import { toast } from "react-toastify";






// All reservation of plateforme
export function fetchCategoryExpenseBigsAll(categoryexpensebig, maintenance
    , expense
    , damage
    , insurance) {
    return async (dispatch) => {
        const params = new URLSearchParams();
        // if (categoryexpensebig) params.append("categoryexpensebig", categoryexpensebig);
        if (maintenance) params.append("maintenance", maintenance);
        if (expense) params.append("expense", expense);
        if (damage) params.append("damage", damage);
        if (insurance) params.append("insurance", insurance);
        dispatch({ type: FETCH_CATEGORY_EXPENSE_BIGS_REQUEST });

        await axios.get(`${baseurl.url}/api/v1/categoryexpensebigs/get_categoryexpensebigs?${params.toString()}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        })
            .then((response) => {
                // console.log(response.data.data);
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS, payload: response.data.data });
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS_2, payload: response.data.data });
            })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIGS_FAILURE, payload: error?.response?.data?.message });
            });
    }
}




// get reservation by id 
export function fetchCategoryExpenseBigsById(idCategoryExpenseBig) {
    return async (dispatch) => {
        dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/expenses/get_expense/${idCategoryExpenseBig}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS, payload: response.data.data });
        })
            .catch((error) => {
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_FAILURE, payload: error?.response?.data?.message })
                //console.log(error);
            });
    }
}






// ✅ Ajouter une nouvelle catégorie de dépense
export function CategoryExpenseBigCreate(expenseCategoryData) {
    return async (dispatch) => {
        dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_REQUEST });

        await axios.post(`${baseurl.url}/api/v1/categoryexpensebigs/create`, expenseCategoryData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        })
            .then((response) => {
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_SUCCESS, payload: response.data.data });
                toast.success(response?.data?.message || "Grande catégorie de dépense ajouter avec succès", { position: "bottom-right" })
                dispatch(fetchCategoryExpenseBigsAll());
            })
            .catch((error) => {
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_FAILURE, payload: error?.response?.data?.message });
                toast.error(error?.response?.data?.message || "Grande catégorie de dépense non ajouter", { position: "bottom-right" })
                dispatch(fetchCategoryExpenseBigsAll());

            });
    }
}

// ✅ Modifier une catégorie de dépense
export function CategoryExpenseBigUpdateById(idCategoryExpenseBig, expenseCategoryData) {
    return async (dispatch) => {
        dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_REQUEST });

        await axios.put(`${baseurl.url}/api/v1/categoryexpensebigs/update/${idCategoryExpenseBig}`, expenseCategoryData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        })
            .then((response) => {
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_SUCCESS, payload: response.data.data });
                toast.success(response?.data?.message || "Grande catégorie de dépense mis à jour avec succès", { position: "bottom-right" })
                dispatch(fetchCategoryExpenseBigsAll());
            })
            .catch((error) => {
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_FAILURE, payload: error?.response?.data?.message });
                toast.error(error?.response?.data?.message || "Grande catégorie de dépense non mis à jour", { position: "bottom-right" })
                dispatch(fetchCategoryExpenseBigsAll());

            });
    }
}

// ✅ Supprimer une catégorie de dépense
export function CategoryExpenseBigDeletedById(idCategoryExpenseBig) {
    return async (dispatch) => {
        dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_REQUEST });

        await axios.delete(`${baseurl.url}/api/v1/categoryexpensebigs/delete/${idCategoryExpenseBig}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        })
            .then((response) => {
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_SUCCESS, payload: idCategoryExpenseBig });
                toast.success(response?.data?.message || "Grande catégorie de dépense supprimer avec succès", { position: "bottom-right" })
                dispatch(fetchCategoryExpenseBigsAll());
            })
            .catch((error) => {
                dispatch({ type: FETCH_CATEGORY_EXPENSE_BIG_FAILURE, payload: error?.response?.data?.message });
                toast.error(error?.response?.data?.message || "Grande catégorie de dépense non supprimer", { position: "bottom-right" })
                dispatch(fetchCategoryExpenseBigsAll());

            });
    }
}



